// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const NewIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M2.73 5.03c.8-.87 1.96-1.36 3.34-1.36h11.86c1.38 0 2.53.5 3.34 1.36.8.86 1.23 2.06 1.23 3.42v7.1c0 1.36-.42 2.55-1.23 3.42-.8.87-1.96 1.35-3.34 1.35H6.07c-1.38 0-2.53-.48-3.34-1.35-.8-.87-1.23-2.06-1.23-3.42v-7.1c0-1.36.43-2.56 1.23-3.42"
      opacity=".5"
    />
    <path
      fill="currentColor"
      d="M9.1 9.83c0-.41-.34-.75-.76-.75-.41 0-.75.34-.75.75v2.1L5.75 9.5c-.2-.26-.54-.36-.84-.26s-.51.4-.51.71v4.34c0 .42.33.75.75.75.41 0 .75-.33.75-.75v-2.1l1.85 2.43c.19.26.53.36.83.26s.51-.39.51-.71zm1.52-.71c-.42 0-.75.34-.75.75v4.26c0 .41.33.75.75.75h2.11c.42 0 .75-.34.75-.75 0-.42-.33-.75-.75-.75h-1.36v-.63h.94c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-.94v-.63h1.36c.42 0 .75-.33.75-.75 0-.41-.33-.75-.75-.75zm4.9.66c-.07-.41-.46-.68-.87-.6-.4.06-.68.45-.6.86l.76 4.21c.05.32.31.57.64.61.32.05.63-.12.77-.42l.77-1.62.77 1.62c.14.3.45.47.78.42.32-.04.58-.29.64-.6l.76-4.22c.07-.4-.2-.8-.6-.87-.42-.07-.8.2-.88.6l-.34 1.92-.45-.94c-.12-.27-.39-.43-.68-.43s-.55.16-.68.43l-.44.94z"
    />
  </SvgIcon>
);

export default NewIcon;
